import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import ResultDisplay from './components/ResultDisplay';
import HeadlineForm from './components/HeadlineForm';

function App() {
  return (
    <>
      <Navbar />
      <div className="container">
        <ResultDisplay />
        <HeadlineForm />
      </div>
    </>
  );
}

export default App;

